<template>
  <div class="APP-BOX clearfix">
    <div class="block_03 clearfix" id="block_033" :style="backImg">
      <div class="block-n_04 clearfix" id="block-n_044">
        <img class="img002" src="../../../static/img/jjf.png" />
        <div class="k-gg">您的剩余积分为：<span>{{points}}</span> 积分</div>
      </div>
    </div>
    <div class="clear"></div>
    <div class="jfzd clearfix">
      <h2>-- 积分制度 --</h2>
      <p><span>一、积分规则：</span><br />A、顾客到院消费，均可获得积分，每消费1元积1分；<br />B、凡推荐新顾客到我院成功消费，推荐人可获得其推荐的新顾客第一次消费产生的积分；<br />C、顾客生日当月消费，享3倍积分（消费1元积3分）；<br />D、积分卡持有人可下载变美APP注册成功并且到院消费后获取3000积分；<br />E、每年年底（12月31日），本年度在12月之前产生的所有积分讲自动清零，12月当月消费积分可以累计到下一年继续使用。</p>
      <p><span>二、积分权益：</span><br />A、积分可以当现金使用来抵扣，100积分=1元。<br />B、积分兑换积分商城的体验项目。1、积分=项目；2、积分+现金=项目；所有兑换规则以积分商城公布的积分和现金兑换比例为准。<br />C、每年底兑换大礼（例如IPhone、奢侈品等礼品）的机会。我院将在变美APP上公告积分兑换实物礼品的制度。</p>
    </div>
  </div>
</template>

<script>
    import {Toast} from 'mint-ui'
    import customerService from "@/services/customer-service.js"
    import commonUtil from '@/utils/commonUtil'

    export default {
        data () {
            return {
                backImg: commonUtil.setBackImg('top-0'),
                points: ''
            }
        },
        created () {
            customerService.getCustomerPoints().then((res)=>{
                if (res.statusCode == 200) {
                    this.points = res.data.points;
                } else {
                    Toast('查询积分失败')
                }
            }).catch((err) => {
                console.log(err)
            })
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/customer/Points.vue